import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "./components/ui/sonner";
import Login from "./pages/Login";
import Dashboard from "./pages/Dashboard";
import Teams from "./pages/Teams";
import Players from "./pages/Players";
import Matches from "./pages/Matches";
import MatchEntry from "./pages/MatchEntry";
import MatchOfficials from "./pages/MatchOfficials";
import Standings from "./pages/Standings";
import Knockout from "./pages/Knockout";
import PlayerStats from "./pages/PlayerStats";
import TeamStats from "./pages/TeamStats";
import Contact from "./pages/Contact";
import Messages from "./pages/Messages";
import Settings from "./pages/Settings";
import Blog from "./pages/Blog";
import BlogManage from "./pages/BlogManage";
import PublicView from "./pages/PublicView";
import Referees from "./pages/Referees";
import Sponsors from "./pages/Sponsors";
import Analytics from "./pages/Analytics";
import Layout from "./components/Layout";
import PublicLayout from "./components/PublicLayout";
import PublicDashboard from "./pages/public/PublicDashboard";
import PublicMatches from "./pages/public/PublicMatches";
import PublicMatchOfficials from "./pages/public/PublicMatchOfficials";
import PublicStandings from "./pages/public/PublicStandings";
import PublicTeams from "./pages/public/PublicTeams";
import PublicPlayers from "./pages/public/PublicPlayers";
import PublicPlayerStats from "./pages/public/PublicPlayerStats";
import PublicTeamStats from "./pages/public/PublicTeamStats";
import PublicKnockout from "./pages/public/PublicKnockout";
import PublicBlog from "./pages/public/PublicBlog";
import PublicContact from "./pages/public/PublicContact";
import PublicSponsors from "./pages/public/PublicSponsors";

const PrivateRoute = ({ children }) => {
  const token = localStorage.getItem("token");
  return token ? children : <Navigate to="/login" replace />;
};

function App() {
  // Public token for the tournament
  const PUBLIC_TOKEN = "6e378397";
  
  return (
    <div className="min-h-screen bg-background">
      <BrowserRouter>
        <Routes>
          {/* Root redirects to public dashboard */}
          <Route path="/" element={<Navigate to={`/public/${PUBLIC_TOKEN}`} replace />} />
          
          {/* Admin login - accessible via /admin or /login */}
          <Route path="/login" element={<Login />} />
          <Route path="/admin" element={<Login />} />
          
          {/* Public routes with full navigation */}
          <Route path="/public/:token" element={<PublicLayout />}>
            <Route index element={<PublicDashboard />} />
            <Route path="dashboard" element={<PublicDashboard />} />
            <Route path="standings" element={<PublicStandings />} />
            <Route path="matches" element={<PublicMatches />} />
            <Route path="match-officials" element={<PublicMatchOfficials />} />
            <Route path="knockout" element={<PublicKnockout />} />
            <Route path="teams" element={<PublicTeams />} />
            <Route path="players" element={<PublicPlayers />} />
            <Route path="player-stats" element={<PublicPlayerStats />} />
            <Route path="team-stats" element={<PublicTeamStats />} />
            <Route path="sponsors" element={<PublicSponsors />} />
            <Route path="blog" element={<PublicBlog />} />
            <Route path="contact" element={<PublicContact />} />
          </Route>

          <Route path="/contact" element={<Contact />} />
          <Route path="/blog" element={<Blog />} />
          
          {/* Admin dashboard - protected routes */}
          <Route
            path="/dashboard"
            element={
              <PrivateRoute>
                <Layout />
              </PrivateRoute>
            }
          >
            <Route index element={<Dashboard />} />
            <Route path="teams" element={<Teams />} />
            <Route path="players" element={<Players />} />
            <Route path="matches" element={<Matches />} />
            <Route path="matches/:matchId" element={<MatchEntry />} />
            <Route path="standings" element={<Standings />} />
            <Route path="knockout" element={<Knockout />} />
            <Route path="player-stats" element={<PlayerStats />} />
            <Route path="team-stats" element={<TeamStats />} />
            <Route path="messages" element={<Messages />} />
            <Route path="referees" element={<Referees />} />
            <Route path="match-officials" element={<MatchOfficials />} />
            <Route path="sponsors" element={<Sponsors />} />
            <Route path="analytics" element={<Analytics />} />
            <Route path="blog-manage" element={<BlogManage />} />
            <Route path="settings" element={<Settings />} />
          </Route>

          {/* Catch-all: redirect unmatched routes to public page */}
          <Route path="*" element={<Navigate to={`/public/${PUBLIC_TOKEN}`} replace />} />
        </Routes>
      </BrowserRouter>
      <Toaster position="top-right" richColors />
    </div>
  );
}

export default App;
